module.exports = __webpack_public_path__ + "img/downloading.5c2a403a.svg";